import { Menu, MenuItem } from "@repo/components/src/ui/menu";
import { ChevronDown } from "lucide-react-native";
import { FieldValues } from "react-hook-form";
import { Box } from "../../../ui/box";
import { Button, ButtonIcon, ButtonText } from "../../../ui/button";
import { HStack } from "../../../ui/hstack";
import { Text } from "../../../ui/text";
import { countryCodesV2 } from "../utils";
import { CountrySelectorProps } from "./types";

function CountrySelector<TFieldValues extends FieldValues>(
  props: CountrySelectorProps<TFieldValues>,
) {
  const { formProps, disabled, selectedCountry, handleCountryChange } = props;
  const {
    buttonProps = {},
    buttonTextProps = {},
    buttonIconProps = {},
  } = formProps.countrySelectorProps ?? {};
  return (
    <Menu
      placement="top"
      offset={5}
      closeOnSelect={true}
      className="rounded-lg flex-1 overflow-scroll"
      trigger={({ ...triggerProps }) => (
        <Button
          {...triggerProps}
          variant="outline"
          action="muted"
          size={formProps.size}
          isDisabled={disabled}
          rounded="2xl"
          {...buttonProps}
          className={`w-32 px-2 ${buttonProps.className ?? ""}`}
        >
          <ButtonText
            {...buttonTextProps}
            className={`flex-1 font-normal ${buttonTextProps.className ?? ""}`}
          >
            {selectedCountry?.flag} {selectedCountry?.dialCode}
          </ButtonText>
          <ButtonIcon as={ChevronDown} {...buttonIconProps} />
        </Button>
      )}
    >
      {countryCodesV2.map((country) => (
        <MenuItem
          key={country.code}
          className="rounded-lg"
          onPress={() => handleCountryChange(country.code)}
          textValue={country.name}
        >
          <HStack space="sm" className="items-center">
            <Text size="lg">{country.flag}</Text>
            <Box className="flex-1">
              <Text size="sm" bold>
                {country.name}
              </Text>
              <Text size="xs" className="text-typography-500">
                {country.dialCode}
              </Text>
            </Box>
          </HStack>
        </MenuItem>
      ))}
    </Menu>
  );
}

export default CountrySelector;
